<div class="row row-cols-2 row-cols-md-2 row-cols-xl-3 g-4">
    <ng-content></ng-content>
</div>